// Auto-generated version file
// This file is updated by the release script
export const APP_VERSION = '1.5.108';
